import React from "react";
import AdminCampsManager from "@/components/admin/AdminCampsManager";

const EditorCamps: React.FC = () => {
  return (
    <AdminCampsManager />
  );
};

export default EditorCamps;